import { SetDate } from 'components/contract-boxes/duration-box/set-date';
import { useDurationBoxProps } from 'contexts/duration-box-props';
import { useDocumentTranslations } from 'components/agreement-loader/document-translations-loader';

export const NoDuration = () => {
  const { startDate } = useDurationBoxProps();
  const { t } = useDocumentTranslations();

  if (!startDate) {
    return (
      <span>
        {t('The contract has no duration.', {
          _comment: 'This message shows that user picked no duration',
        })}
      </span>
    );
  }

  return (
    <span>
      {t('The start date for the contract is {setStartDateComponent}.', {
        _comment: 'Text to show the start date of contract.',
        setStartDateComponent: <SetDate dateType="startDate" />,
      })}
    </span>
  );
};
